import React from "react";
import { Link, useLocation } from "react-router-dom";
import Image from "../ui/Image";
import Logo from "../../assets/prodicus_logo_cropped.webp";

export default function Navbar() {
  const location = useLocation();
  const isAdminLogin = location.pathname.includes("admin-login");

  let NavLoginText = "Admin Login";
  let navLoginLink = "/admin-login";
  if(isAdminLogin) {
    navLoginLink = "/";
    NavLoginText = "Agent Login";
  }

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="navbar-brand">
          <div className="navbar-logo-placeholder">
            <Image src={Logo} alt="Prodicus Logo" className="navbar-logo" />
          </div>
        </Link>
      </div>
      <div className="navbar-right">
        <Link to={navLoginLink} className="navbar-link">
          {NavLoginText}
        </Link>
      </div>
    </nav>
  );
}
